// Interfaces für Sponsor-Agreements im Frontend

import {AdvertisementType} from "@/lib/api/interfaces/advertisements.interface";

export interface FileDetailsResponseDto {
  name: string;
  path: string;
  size: number;
  mimetype: string;
}

export enum AgreementStatus {
  PENDING = "pending",
  ACCEPTED = "accepted",
  REJECTED = "rejected",
}

export enum SponsorMandantType {
  VEREIN = "Verein",
  SPIELBETRIEBS_GMBH = "Spielbetriebs GmbH",
  FOERDERVEREIN = "Förderverein",
}

export interface SponsorAgreementResponseDto {
  _id: string;
  sponsorId: string;
  departmentName: string;
  advertisementIds: string[];
  advertisementType: AdvertisementType;
  documents?: FileDetailsResponseDto[];
  startDate?: string; // ISO-String
  endDate?: string; // ISO-String
  duration?: number;
  volume?: number;
  status: AgreementStatus;
  mandantType: SponsorMandantType;
}

export interface AgreementDocumentUrlResponseDto {
  url: string;
  name: string;
  mimetype: string;
  size: number;
}

export interface CreateSponsorAgreementRequestDto {
  advertisementIds: string[];
  /** Startdatum des Agreements (ISO-String) */
  startDate: string;
  /** Enddatum des Agreements (ISO-String, optional bei Einmalzahlung) */
  endDate?: string;
  /** Laufzeit in Tagen (optional, wird sonst im Backend berechnet) */
  duration?: number;
  /** Volumen des Agreements (z.B. Betrag) */
  volume?: number;
  isPostable: boolean;
  status?: AgreementStatus;
  /** Optionaler Typ des Agreements (Spende/Sponsoring); wird sonst aus der Leistung abgeleitet */
  type?: AdvertisementType;
  mandantType?: SponsorMandantType;
}

export interface UpdateSponsorAgreementRequestDto
  extends Partial<CreateSponsorAgreementRequestDto> {}

export interface SponsorAgreementAdvertisementResponseDto {
  advertisementId: string;
  advertisementName: string;
  departmentName: string;
  defaultDuration?: number;
  defaultVolume?: number;
  defaultInterval?: string;
  show_on_social_media?: boolean;
  type: AdvertisementType;
}
